import type {
  BundleCabinMarkupFormRow,
  BundleCabinTypeMarkup,
  BundleCabinTypeMarkupInput,
} from '~/components/Cruises/pages/Bundles/types';

const FIXED_CABIN_TYPE_FIELDS: Array<{ cabinType: string; label: string }> = [
  { cabinType: 'inside', label: 'Inside' },
  { cabinType: 'oceanview', label: 'Oceanview' },
  { cabinType: 'balcony', label: 'Balcony' },
  { cabinType: 'suite', label: 'Suite' },
];

export function buildFixedCabinMarkupRows(): Array<BundleCabinMarkupFormRow> {
  return FIXED_CABIN_TYPE_FIELDS.map((field) => ({
    cabinType: field.cabinType,
    label: field.label,
    markupPercent: '',
  }));
}

export function mergeFixedCabinMarkupRows(markups: Array<BundleCabinTypeMarkup>): Array<BundleCabinMarkupFormRow> {
  const markupByCabinType = new Map(
    markups.map((row) => [normalizeBundleCabinTypeKey(row.cabinType), row.markup * 100]),
  );

  return FIXED_CABIN_TYPE_FIELDS.map((field) => ({
    cabinType: field.cabinType,
    label: field.label,
    markupPercent: markupByCabinType.get(field.cabinType) ?? '',
  }));
}

export function normalizeBundleCabinTypeKey(cabinType: string): string {
  return cabinType.trim().toLowerCase();
}

export function validateBundleCabinMarkupRows(rows: Array<BundleCabinMarkupFormRow>): string | undefined {
  for (const row of rows) {
    if (row.markupPercent === '') {
      return `Enter markup (%) for all cabin types, including ${row.label}`;
    }
    if (row.markupPercent < 0 || row.markupPercent > 100) {
      return 'Per-cabin markup must be between 0 and 100%';
    }
  }
  return undefined;
}

export function bundleCabinMarkupRowsToApi(rows: Array<BundleCabinMarkupFormRow>): Array<BundleCabinTypeMarkupInput> {
  return rows.map((row) => {
    const pct = row.markupPercent;
    if (pct === '') {
      throw new Error('bundleCabinMarkupRowsToApi expects validated, complete cabin markup rows');
    }
    return {
      cabinType: row.cabinType.trim(),
      markup: pct / 100,
    };
  });
}
